<div *ngIf="!isErrResponse && !isEmptyRetirementLink && enableMarketingMessage" class="container mmm-container" [ngClass]="marginTop" [id]="id">
    <input  type="hidden" name="contentId" [value]="contentId">
    <pru-marketing-messages-manager-layouts *ngIf="marketingSlotsContent" [marketingContents]="marketingSlotsContent" [contentId]="contentId"
                                    [retirementLink]="retirementLink">
    </pru-marketing-messages-manager-layouts> 
</div>

